import { CollapsibleSection } from 'components/generic/CollapsibleSection'
import SelectivityDropdown from 'components/generic/SelectivityDropdown'
import Icon from 'components/Icon'
import { Button, Div, Em, H2, Input, Label, P, Range, VArray, Number as NumberInput, Span, reactive, A, not } from 'alkali'
import {
	selectedCharacteristics,
	selectedCharacteristicIds,
	selectedOutcomes,
	selectedOutcomeIds,
	selectedTreatments,
	selectedTreatmentIds,
	groupedInterventions,
} from 'model/EvidenceSearch'
import { executeSearch, analysisType, structuredQuery, analysisSelections, analyzeTreatmentMap } from 'model/SearchQuery'
import { OutcomesGrid } from 'components/filter/OutcomesGrid'
import { InterventionsGrid } from 'components/filter/InterventionsGrid'
import { CharacteristicsGrid } from 'components/filter/CharacteristicsGrid'
import { StudyFilter } from 'components/filter/StudyFilter'
import app from '../../app/app'
import './FilterPane.scss'
import { studyFilter } from 'model/SearchQuery'
import { removeContents } from 'components/entry/Explanation'
import * as networkIcon from 'icons/hierarchy-1.svg'
import { track } from 'components/tracking/track'
import { openFilterPane } from 'components/navbar/FilterButton'
export default class FilterPane extends Div('.filter-pane', {
	classes: {
		'can-edit-concepts': app.authdUser,
		'medium-open-filter': openFilterPane,
		'medium-hide-filter': not(openFilterPane),
},
	onfocusin() {
		this.classList.add('has-focus')
	},
	onfocusout() {
		this.classList.remove('has-focus')
	},
}) {
	ready(properties) {
		let treatmentsWidget, charWidget, outcomesWidget
		let outcomeTitle = selectedOutcomes.to(outcomes =>
			outcomes.length > 0
				? (outcomes.length > 1 ? 'Outcomes' : 'Outcome')
				: 'Outcomes/Measures'
		)
		let characteristicTitle = selectedCharacteristics.to(characteristics =>
			characteristics.length > 0
				? (characteristics.length > 1 ? 'Conditions' : 'Condition ')
				: 'Conditions/Characteristics',
		)		
		let treatmentTitle = groupedInterventions.to(treatments =>
			treatments.length > 0 ? (treatments.length > 1 ? 'Treatments' : 'Treatment') : 'Treatments/Exposure')
		this.append(
			CollapsibleSection('.filter.filter-characteristics', {
				classes: {
					'is-filtering': selectedCharacteristicIds.to(selectedCharacteristicIds => selectedCharacteristicIds.length > 0),
				},
				header: H2({
					content: characteristicTitle,
				}),
				body: charWidget = new Div([
					CharacteristicsGrid
				]),
			}),
			CollapsibleSection('.filter.filter-treatments', {
				classes: {
					'is-filtering': structuredQuery.to(({ interventions }) => interventions.length > 0),
					'needs-selection': structuredQuery.to(({ interventions }) => interventions.length == 0),
				},
				header: H2({
					content: treatmentTitle,
					title: structuredQuery.to(({ interventions }) => interventions.length == 0 ?
						selectedTreatmentIds.to(ids => ids.length > 0 ?
						'Treatments were auto-selected, please choose treatment of interest.' :
						'Please choose treatment of interest.') :
						'')
				}),
				body: treatmentsWidget = new Div('.intervention-pico', [
					InterventionsGrid
				])
			}),
			CollapsibleSection('.filter.filter-outcomes', {
				classes: {
					'is-filtering': structuredQuery.to(({ outcomes }) => outcomes.length > 0),
					'needs-selection': structuredQuery.to(({ outcomes }) => outcomes.length == 0),
				},
				header: H2({
					content: outcomeTitle,
					title: structuredQuery.to(({ outcomes }) => outcomes.length == 0 ?
						selectedOutcomeIds.to(ids => ids.length > 0 ?
							'Outcome was auto-selected, please choose outcome of interest.' :
							'Select an outcome from the outcome filter to start building an analysis.') :
						''),
				}),
				body: outcomesWidget = new Div([
					OutcomesGrid
				]),
			}),
			CollapsibleSection('.filter.filter-study', {
				classes: {
					'is-filtering': studyFilter.to(studyFilter => studyFilter && (studyFilter.published > 1970 || studyFilter.importCollection || studyFilter.sources?.length > 0 || studyFilter.designs?.length > 0)),
				},
				header: H2({
					title: 'Study',
					content: 'Study',
				}),
				body: new StudyFilter,
				open: studyFilter.then(studyFilter =>
					studyFilter && (studyFilter.published > 1970 || studyFilter.importCollection || studyFilter.sources?.length > 0 || studyFilter.designs?.length > 0)),
			}),
		)
	}
}